import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CertificateEntries from './CertificateEntries';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from "../../app/containers/IsSpinning";
import styles from "../../addressbook/containers/css/List.scss";
import Icon from "../../../ui/Icon";

export class Dashboard extends Component {
    static propTypes = {
        children: PropTypes.node,
        session: ImmutablePropTypes.map,
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const {session} = this.props;
        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.certificate.text.info' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <CertificateEntries session={session}/>
                </Page.Section>
                <IsSpinning id='certificate'>
                    <div className={styles.loadingMessage}>
                        <Icon name='refresh' spin fixedWidth />{' '}
                        <FormattedMessage id='common.helper.please_wait' />
                    </div>
                </IsSpinning>
            </Page.Body>
        );
    }
}

export default connect(state => ({
    session: state.session,
}))(Dashboard);
